export function initHome() {
	const handleLatestNewsLayoutChange = (e) => {
		e.preventDefault();
		const section = document.getElementById("latestNews");
		const posts = section.querySelectorAll(".post");
		const view = e.target.dataset.id;

		if (posts.length > 0) {
			posts.forEach((post) => {
				post.className = `post ${view}`;
			});
		}
	};

	window.initDropdowns?.(
		"#latestNews .dropdown",
		handleLatestNewsLayoutChange,
	);
}
